module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-navigation-drawer', {
    attrs: {
      "mobile-break-point": "10240",
      "clipped": "",
      "fixed": "",
      "hide-overlay": "",
      "app": ""
    },
    model: {
      value: (_vm.sideProps),
      callback: function($$v) {
        _vm.sideProps = $$v
      },
      expression: "sideProps"
    }
  }, [_c('v-list', {
    attrs: {
      "dense": ""
    }
  }, [_c('div', {
    staticClass: "menu_holder"
  }, [_c('v-list-tile', {
    on: {
      "click": function($event) {
        return _vm.fncShowSettings()
      }
    }
  }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v("settings")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("General Settings")])], 1)], 1)], 1), _vm._v(" "), _vm._l((_vm.menu), function(item, index) {
    return _c('div', {
      key: item.id,
      staticClass: "menu_holder"
    }, [(_vm.objAuthorize.privileges.indexOf(item.priv) !== -1 || item.priv === 'All') ? _c('v-list-tile', {
      on: {
        "click": function($event) {
          return _vm.showNavChildren(item.id, item.link, index)
        }
      }
    }, [_c('v-list-tile-action', [_c('v-icon', {
      style: ({
        color: item.color
      })
    }, [_vm._v(_vm._s(item.icon))])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(item.title))])], 1)], 1) : _vm._e(), _vm._v(" "), _vm._l((item.children), function(subItem, subIndex) {
      return (_vm.clickStatus[index][item.id] && _vm.objAuthorize.privileges.indexOf(subItem.priv) !== -1 || subItem.priv === 'All') ? _c('v-list-tile', {
        key: subItem.id,
        staticClass: "navChild"
      }, [_c('v-list-tile-content', [_c('v-list-tile-title', {
        staticClass: "cursor",
        on: {
          "click": function($event) {
            return _vm.fncGoPage(subItem.link)
          }
        }
      }, [_c('span', {
        staticClass: "subIcon",
        style: ({
          background: item.color
        })
      }, [_vm._v(_vm._s(_vm.showFirstLetter(subItem.title)))]), _vm._v(_vm._s(_vm.fncSubMenuTitle(subItem.title)))])], 1)], 1) : _vm._e()
    })], 2)
  }), _vm._v(" "), _c('div', {
    staticClass: "menu_holder"
  }, [_c('v-list-tile', {
    on: {
      "click": function($event) {
        return _vm.fncClearStorage()
      }
    }
  }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v("filter_list")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Clear All Filters")])], 1)], 1)], 1)], 2)], 1)
},staticRenderFns: []}